var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.97 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "connect-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plug-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plug-left-2",
    "data-name": "plug-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    "data-name": "path0 fill",
    className: "cls-1",
    d: "M40,13.35H34.11V8.65H40a1.92,1.92,0,1,0,0-3.84H34.11V1.92A1.92,1.92,0,0,0,32.19,0H24.52A11,11,0,0,0,13.7,9.08H1.92a1.92,1.92,0,1,0,0,3.84H13.7A11,11,0,0,0,24.52,22h7.67a1.92,1.92,0,0,0,1.92-1.92V17.19H40a1.92,1.92,0,0,0,0-3.84ZM24.52,18.16a7.16,7.16,0,1,1,0-14.32h5.75V18.16Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectLeft);
export default __webpack_public_path__ + "static/media/connect-left.affeb48320fb99f9f7c1e9872aa06334.svg";
export { ForwardRef as ReactComponent };